import {
    LocalizationAction,
    LocalizationActionType,
} from '../actions/localization/localizationAction';
import { getLocalization } from '../../localization/localization';
import { Localizations } from '../../localization/definitions/enums';
import { ILocalization } from '../../localization/definitions/types';

const INITIAL_LOCALIZATION: ILocalization = {
    currentLanguage: Localizations.en,
    localizationStrings: getLocalization(Localizations.en),
};

const localizationReducer = (
    state: ILocalization = INITIAL_LOCALIZATION,
    action: LocalizationAction
) => {
    switch (action.type) {
        case LocalizationActionType.CHANGE_LANGUAGE:
            return {
                currentLanguage: action.payload,
                localizationStrings: getLocalization(action.payload),
            };
        default:
            return state;
    }
};

export default localizationReducer;
